<style lang="stylus">
    .pixabay
        .pixabay-topbar
            display flex
            align-items center
            justify-content space-between
            height 40px
            padding 0 16px
            border-bottom 1px solid var(--border-color-gray1)
            .header-prefix
                display flex
                align-items center
                >p
                    font-size 14px
                    font-weight 700
                    color var(--text-color-primary)
                    margin-right 4px
                >img
                    width 24px
                    height 24px
                    margin-right 4px
                .ivu-tooltip
                    margin-bottom auto
                    .ivu-tooltip-rel
                        display block
                        width 8px
                        height 8px
                        svg
                            width 8px
                            height 8px
                            color: var(--svg-color-black);
                            display block;
                            // 这里原来就是黑色模式
                    .ivu-tooltip-arrow
                        border-bottom-color var(--border-color-tips) !important
                    .ivu-tooltip-inner
                        background-color var(--bg-color-tips) !important
                        border-radius 8px
                        p
                            line-height 20px
                            color #fff
                            font-size 12px
                            text-align left !important
            .pixabay-aientry
                display flex
                align-items center
                font-size 12px
                color var(--text-color-primary)
                cursor pointer
                img
                    width 24px
                    height 24px
                p
                    color var(--themeColor)
        .pixabay-searchblock
            padding 16px 16px 0 16px
            margin-bottom 8px

        .pixabay-preview
            width 100%
            height calc(100% - 96px)
            padding 0 16px
            overflow auto
            .preview-block
                position relative
                margin-bottom 8px
                .preview-topbar
                    display flex
                    align-items center
                    justify-content space-between
                    height 40px
                    font-size 12px
                    color var(--text-color-primary)
                    margin-bottom 4px
                    .preview-topbar-title
                        font-weight 700
                        font-size 14px
                    .preview-topbar-btn
                        display flex
                        align-items center
                        cursor pointer
                        svg
                            margin-left 4px
                            width 16px
                            height 16px
                            color var(--svg-color-primary)
                        &:hover
                            color var(--themeColor)
                            svg
                                color var(--themeColor)
                .preview-imgbox
                    display flex
                    column-gap  8px
                    width 100%
                    height 80px
                    overflow-x auto
                    &::-webkit-scrollbar
                        display none
                    img
                        border-radius 8px
                        height 100%
                        object-fit contain
                        cursor pointer
                .preview-imgbox-arrow
                    display none
                    position absolute
                    width 24px
                    height 24px
                    filter drop-shadow(0px 2px 10px var(--border-color-gray1))
                    top 72px
                    cursor pointer
                .preview-imgbox-left
                    left -12px
                    &.is-dark
                        transform rotate(180deg)
                .preview-imgbox-right
                    transform rotate(180deg)
                    &.is-dark
                        transform rotate(0deg)
                    right -12px
                &:hover
                    .preview-imgbox-arrow
                        display block
        .pixabay-detail
            width 100%
            height calc(100% - 48px)
            margin-top 8px
            .detail-topbar
                display flex
                padding 0 16px
                align-items center
                justify-content space-between
                height 40px
                .detail-back
                    display flex
                    align-items center
                    cursor pointer
                    svg
                        width 16px
                        height 16px
                        transform rotate(180deg)
                        margin-right 4px
                        color: var(--svg-color-primary);
                    p
                        font-size 12px
                        color var(--text-color-primary)
                .detail-reset
                    width 16px
                    height 16px
                    margin-right 6px
                    cursor pointer
                    svg
                        width 16px
                        height 16px
                        color: var(--svg-color-primary);
            .detail-tool
                display flex
                padding 0 16px
                column-gap 8px
                .z-dropdown
                    min-width 86px
                .detail-color
                    position relative
                    display flex
                    justify-content center
                    align-items center
                    width 28px
                    height 28px
                    border 1px solid var(--border-color-gray2)
                    border-radius 4px
                    cursor pointer
                    flex-shrink 0
                    img
                        width 16px
                        height 16px
                    .detail-colorbox
                        position absolute
                        right 0
                        top 28px
                        width 144px
                        height 188px
                        padding 16px
                        border-radius 8px
                        color var(--text-color-primary)
                        background var(--bg-color-tertiary)
                        box-shadow $box-shadow
                        .colorbox-checkbox
                            display flex
                            align-items center
                            height 28px
                            .ivu-checkbox
                                margin-right 4px
                                &:not(.ivu-checkbox-checked)
                                    .ivu-checkbox-inner
                                        background-color var(--bg-color-tertiary)
                        .colorbox-colorbox
                            display flex
                            flex-wrap wrap
                            width 128px
                            margin-top 6px
                            margin-left -2px
                            &.ban
                                opacity .3
                                pointer-events none
                            .colorbox-item
                                height 26px
                                width 26px
                                cursor pointer
                                padding 1px
                                border-radius 50%
                                border 1px solid transparent
                                margin-right 4px
                                margin-bottom 8px

                                &.active
                                    border-color var(--themeColor)

                                &:not(.active):hover
                                    border-color var(--color-black-10)
                                    border 1px solid var(--color-black-10)

                                &:nth-child(4n)
                                    margin-right 0
                                    margin-bottom 0

                                &:nth-child(n+8)
                                    margin-bottom 0

                                .colorbox-itembox
                                    width 22px
                                    height 22px
                                    border-radius 50%
                                    border 1px solid var(--color-black-10)
            .detail-imgbox
                display flex
                flex-wrap wrap
                align-content flex-start
                padding 0 10px 0 16px
                column-gap 8px
                width 100%
                margin-top 16px
                height calc(100% - 84px)
                overflow-y auto
                .detail-imgbox-left,.detail-imgbox-right
                    width calc(50% - 4px)
                    display flex
                    flex-direction column
                    row-gap 8px
                img
                    width 100%
                    border-radius 6px
                    object-fit contain
                    cursor pointer
                .detail-imgbox-loading
                    width 100%
                    display flex
                    justify-content center
                    align-items center
                    svg
                        color var(--themeColor)
                .detail-empty
                    width 100%
                    height 100%
                    display flex
                    justify-content center
                    align-items center
                    p
                        font-size 14px
                        color var(--text-color-primary)
</style>

<template>
    <div class="pixabay">
        <div class="pixabay-topbar">
            <a class="header-prefix" href="https://pixabay.com/" target="_blank">
                <img src="@/app/assets/leftPanel/pixabay/pixabay.svg" alt="" />
                <p>Pixabay</p>
                <Tooltip @click.native.prevent class="tips-mark" :max-width="200" placement="bottom">
                    <iconSymbol name="copyright" />
                    <div slot="content">
                        <p>{{ $t("tips") }}</p>
                    </div>
                </Tooltip>
            </a>
            <div v-if="EDCONFIG.AI.ENABLE && EDCONFIG.AI.DRAW_ENABLE" class="pixabay-aientry" @click="showAiDraw">
                <img src="@/app/assets/leftPanel/pixabay/ai.svg" alt="" />
                <p>{{ $t("aiDraw") }}</p>
            </div>
        </div>

        <div class="pixabay-searchblock" v-if="status == 0">
            <Search v-model="searchStr" @toSearch="toSearch" :placeholderStr="$t('placeholder')" />
        </div>

        <div class="pixabay-preview" v-if="status == 0">
            <div class="preview-block" v-for="(item, index) in previewList">
                <div class="preview-topbar">
                    <div class="preview-topbar-title">{{ $t(item.label) }}</div>
                    <div class="preview-topbar-btn" @click="toDetail(item.label)">
                        <!-- <p>{{ $t("all") }}</p> -->
                        <iconSymbol name="leftpanel-right-arrow" />
                    </div>
                </div>
                <img
                    v-show="scrollList[index][0]"
                    class="preview-imgbox-left preview-imgbox-arrow"
                    :class="{ 'is-dark': isDarkTheme() }"
                    :src="require(`@/app/assets/leftPanel/pixabay/preview-arrow${isDarkTheme() ? '-dark' : ''}.png`)"
                    alt=""
                    @click="doMoveLeft(index)"
                />
                <div class="preview-imgbox" ref="previewBlocks">
                    <img
                        v-for="img in item.imgList"
                        :src="img.previewUrl || img.imgUrl"
                        alt=""
                        draggable="false"
                        @mousedown="doMousedown(img, item.label)"
                    />
                </div>
                <img
                    v-show="scrollList[index][1]"
                    class="preview-imgbox-right preview-imgbox-arrow"
                    :class="{ 'is-dark': isDarkTheme() }"
                    :src="require(`@/app/assets/leftPanel/pixabay/preview-arrow${isDarkTheme() ? '-dark' : ''}.png`)"
                    alt=""
                    @click="doMoveRight(index)"
                />
            </div>
        </div>

        <div class="pixabay-detail" v-if="status == 1">
            <div class="detail-topbar">
                <div class="detail-back" @click="backToPreview">
                    <iconSymbol name="leftpanel-right-arrow" />
                    <p>{{ keyWord }}</p>
                </div>
                <div class="detail-reset" @click="resetParams">
                    <iconSymbol name="reset" />
                </div>
            </div>

            <div class="detail-tool">
                <Dropdown v-model="typeIndex" :dataList="typeList" @selectData="setImageType"></Dropdown>
                <Dropdown v-model="directionIndex" :dataList="directionList" @selectData="setDirection"></Dropdown>
                <div class="detail-color" ref="colorboxEl">
                    <img src="@/app/assets/leftPanel/public/color.png" alt="" @click="toggleColor" />
                    <div v-show="showColorbox" class="detail-colorbox">
                        <div class="colorbox-checkbox">
                            <Checkbox v-model="isTransparent" @on-change="setTrans">{{ $t("transparent") }}</Checkbox>
                        </div>
                        <div class="colorbox-checkbox">
                            <Checkbox v-model="isGray" @on-change="setGray">{{ $t("grayscale") }}</Checkbox>
                        </div>
                        <div class="colorbox-colorbox" :class="{ ban: isGray }">
                            <div
                                class="colorbox-item"
                                :class="{
                                    active: item.value == activeColor,
                                }"
                                v-for="item in colorList"
                                :key="item.id"
                                @click="clickColor(item.id)"
                            >
                                <div class="colorbox-itembox" :style="{ background: item.color }"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-imgbox">
                <div class="detail-imgbox-left" :style="{ height: `${leftHeight}px` }">
                    <img v-for="img in leftList" :src="img.previewUrl || img.imgUrl" alt="" draggable="false" @mousedown="doMousedown(img)" />
                </div>
                <div class="detail-imgbox-right" :style="{ height: `${rightHeight}px` }">
                    <img v-for="img in rightList" :src="img.previewUrl || img.imgUrl" alt="" draggable="false" @mousedown="doMousedown(img)" />
                </div>
                <div v-show="loading" class="detail-imgbox-loading">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="24"
                        height="24px"
                        viewBox="0 0 50 50"
                        style="enable-background: new 0 0 50 50"
                        xml:space="preserve"
                    >
                        <path
                            fill="currentColor"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                        >
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="0.8s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>
                <div v-show="!end && !loading" ref="scrollEl" style="height: 10px"></div>
                <div v-if="!loading && leftList.length == 0 && rightList.length == 0" class="detail-empty">
                    <p>{{ $t("nodata") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Search from "./public/_Search.vue";
    import Dropdown from "./public/_Dropdown.vue";

    @Component({
        components: {
            Search,
            Dropdown,
        },
    })
    export default class Pixabay extends Vue {
        trackKey = "";
        status = 0;
        searchStr = "";
        toSearch() {
            if (this.searchStr == "") {
                this.reset();
                this.status = 0;
                return;
            }
            this.keyWord = this.searchStr;
            this.status = 1;
            this.initList();
        }

        agree = false;
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get agreePlus() {
            return this.agree || this.noLoginEditor;
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
            return this.agree;
        }

        showAgreement() {
            this.$store.commit("setDialogState", {
                type: "aiDrawBtn",
                data: "",
            });
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }

        showAiDraw() {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                this.$store.commit("setDialogState", {
                    type: "aiDrawBtn",
                    data: "pixabayShowAiDraw",
                });
                return;
            }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "AIDraw",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$nextTick(() => {
                this.$bus.$emit("setAidrawOption", {
                    menu: 0,
                    style: 2,
                });
            });
            this.sensors.track("openAiDrawingWindow", {
                Catalogues: "AiDrawing",
                open_way: "leftMenuAiImages",
                similar_library_name: "unknown",
                similar_symbol_name: "unknown",
                search_symbol_content: "unknown",
            });
        }

        previewList = [];
        scrollList = [];
        isSvg(url: string | undefined) {
            if (!url) {
                return false;
            }
            let arr = url.split(".");
            return arr.length > 1 && arr[arr.length - 1] == "svg";
        }
        async getPreviewData() {
            let params = {
                image_type: "all",
                orientation: "all",
                colors: "",
                page: 1,
                pageSize: 5,
                lang: this.lang,
            };
            let list = [
                "science",
                "backgrounds",
                "places",
                "flower",
                "city",
                "business",
                "educate",
                "starSky",
                "sky",
                "snow",
                "cartoon",
                "car",
                "animal",
                "figure",
                "travel",
            ];
            const getData = (word: string) => {
                let p = Object.assign({ q: word }, params);
                return this.$edApi.getPixabayData(p);
            };
            for (let i = 0; i < list.length; i++) {
                let obj = {
                    id: i,
                    label: list[i],
                    imgList: [],
                };
                const res = await getData(list[i]);
                this.sensors.track("openLibrarySuccess", {
                    Catalogues: "editFileProcess",
                    name: this.$tc(list[i], 1, "en"),
                    class: "picture",
                });
                for (let item of res.data.hits) {
                    let svg = this.isSvg(item.vectorURL);
                    obj.imgList.push({
                        isSvg: svg ? true : false,
                        previewUrl: item.previewURL,
                        imgUrl: svg ? item.vectorURL : item.largeImageURL,
                        w: item.imageWidth,
                        h: item.imageHeight,
                    });
                }
                if (obj.imgList.length > 0) {
                    this.previewList.push(obj);
                    this.scrollList.push([false, true]);
                }
            }
        }
        initScrollList() {
            this.scrollList.forEach((item) => ((item[0] = false), (item[1] = true)));
        }
        getWebImg(url: string) {
            return this.$edApi.getInternetImage({ url });
        }
        getWebSvg(url: string) {
            return this.$edApi.basicGet({ url });
        }
        loading = false;
        doImage(obj) {
            let { image, setPosition, left, top } = obj;
            if (this.loading) return;
            this.loading = true;
            this.setLoading(true);
            if (image.isSvg) {
                this.getWebSvg(image.imgUrl)
                    .then((data) => {
                        if (setPosition) {
                            window["_view"].insertSVGFromStr(data, false, 0, 0, "", setPosition, left, top);
                        } else {
                            window["_view"].insertSVGFromStr(data, false, 0, 0, "");
                        }
                    })
                    .finally(() => {
                        this.setLoading(false);
                        this.loading = false;
                    });
            } else {
                const result = /\.[^\.]+$/.exec(image.imageURL);
                const suffix = result ? result[0] : ".png";
                this.getWebImg(image.imgUrl)
                    .then((blob) => {
                        if (setPosition) {
                            window["_view"].insertImageFromOL(blob, suffix, true, setPosition, left, top).then(() => {
                                window["_view"].invalidate();
                            });
                        } else {
                            window["_view"].insertImageFromOL(blob, suffix, true).then(() => {
                                window["_view"].invalidate();
                            });
                        }
                    })
                    .finally(() => {
                        this.setLoading(false);
                        this.loading = false;
                    });
            }
        }

        imgDom = null;
        createPreview(imgUrl) {
            this.imgDom = document.createElement("img");
            this.imgDom.src = imgUrl;
            this.imgDom.id = "previewIMG";
            this.imgDom.style.cssText = `
                display: none;
                position:absolute;
                left: -999px;
                top: -999px;
                width: 32px;
                height: 32px;
                object-fit:contain;
                pointer-events:none;
                z-index: 1000;
            `;
            document.body.appendChild(this.imgDom);
        }
        movePreview(x: number, y: number) {
            if (this.imgDom) {
                this.imgDom.style.left = `${x}px`;
                this.imgDom.style.top = `${y}px`;
            }
        }
        hiddenPreview() {
            this.imgDom && (this.imgDom.style.display = "none");
        }
        showPreview() {
            this.imgDom && (this.imgDom.style.display = "block");
        }
        removePreview() {
            if (this.imgDom) {
                document.body.removeChild(this.imgDom);
                this.imgDom = null;
            }
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }
        setLoading(status) {
            this.$store.commit("setStatus", {
                type: "Loading",
                data: status,
            });
        }
        doMousedown(image, key?) {
            let isMove = false;
            if (key) {
                this.trackKey = this.$tc(key, 1, "en");
            }
            this.createPreview(image.previewUrl);
            let timer = setTimeout(() => {
                isMove = true;
            }, 150);

            document.onmousemove = (ev: MouseEvent) => {
                if (!isMove) return;
                this.showPreview();
                const imgWidth = 32,
                    imgHeight = 32;
                this.movePreview(ev.pageX - imgWidth / 2, ev.pageY - imgHeight / 2);
            };
            document.onmouseup = (ev: MouseEvent) => {
                clearTimeout(timer);
                const left = ev.pageX - this.sceneLeft,
                    top = ev.pageY - this.sceneTop;
                const setPosition = true;
                document.onmousemove = null;
                document.onmouseup = null;
                this.sensors.track("useSymbolLibrary", {
                    Catalogues: "editFileProcess",
                    symbol_library_name: this.trackKey,
                    symbol_library_class: "picture",
                });
                this.removePreview();
                if (isMove) {
                    if (left > 0 && top > 0) {
                        this.doImage({ image, setPosition, left, top });
                    }
                } else {
                    this.doImage({ image });
                }
            };
        }
        doMoveLeft(index) {
            const boxList = this.$refs.previewBlocks;
            if (boxList[index]) {
                const boxWidth = boxList[index].clientWidth;
                const scrollWidth = boxList[index].scrollWidth;
                const scrollLeft = boxList[index].scrollLeft;
                let scroll = scrollLeft - (scrollWidth - boxWidth) / 3;
                if (scroll < 0) {
                    scroll = 0;
                }
                boxList[index].scrollTo({ top: 0, left: scroll, behavior: "smooth" });
                this.changeScrollDisplay(index, boxWidth, scrollWidth, scroll);
            }
        }
        doMoveRight(index) {
            const boxList = this.$refs.previewBlocks;
            if (boxList[index]) {
                const boxWidth = boxList[index].clientWidth;
                const scrollWidth = boxList[index].scrollWidth;
                const scrollLeft = boxList[index].scrollLeft;
                let scroll = scrollLeft + (scrollWidth - boxWidth) / 3;
                if (scroll >= scrollWidth - boxWidth - 20) {
                    scroll = scrollWidth - boxWidth;
                }
                boxList[index].scrollTo({ top: 0, left: scroll, behavior: "smooth" });
                this.changeScrollDisplay(index, boxWidth, scrollWidth, scroll);
            }
        }
        changeScrollDisplay(i, boxw, w, l) {
            if (l == 0) {
                this.scrollList[i].splice(0, 1, false);
            } else {
                this.scrollList[i].splice(0, 1, true);
            }
            if (boxw + l == w) {
                this.scrollList[i].splice(1, 1, false);
            } else {
                this.scrollList[i].splice(1, 1, true);
            }
        }

        toDetail(key) {
            this.status = 1;
            this.keyWord = this.$tc(key);
            this.trackKey = this.$tc(key, 1, "en");
            this.initList();
        }
        reloadWithParams() {
            this.reset();
            this.params.image_type = this.typeList[this.typeIndex].value;
            this.params.orientation = this.directionList[this.directionIndex].value;
            this.params.colors = this.colors;
            this.initList();
        }
        keyWord = "";
        typeIndex = 0;
        get typeList() {
            return [
                {
                    label: this.$t("all"),
                    value: "all",
                },
                {
                    label: this.$t("photo"),
                    value: "photo",
                },
                {
                    label: this.$t("vector"),
                    value: "vector",
                },
                {
                    label: this.$t("illustration"),
                    value: "illustration",
                },
            ];
        }
        setImageType() {
            this.reloadWithParams();
        }
        directionIndex = 0;
        get directionList() {
            return [
                {
                    label: this.$t("allDirection"),
                    value: "all",
                },
                {
                    label: this.$t("horizontal"),
                    value: "horizontal",
                },
                {
                    label: this.$t("vertical"),
                    value: "vertical",
                },
            ];
        }
        setDirection() {
            this.reloadWithParams();
        }
        isTransparent = false;
        isGray = false;
        activeColor = "";
        colorList = [
            {
                id: 0,
                color: "#ff0000",
                value: "red",
            },
            {
                id: 1,
                color: "#fdb91a",
                value: "orange",
            },
            {
                id: 2,
                color: "#ffee00",
                value: "yellow",
            },
            {
                id: 3,
                color: "#00e100",
                value: "green",
            },
            {
                id: 4,
                color: "#00d7e8",
                value: "turquoise",
            },
            {
                id: 5,
                color: "#0000ff",
                value: "blue",
            },
            {
                id: 6,
                color: "#c93ef7",
                value: "lilac",
            },
            {
                id: 7,
                color: "#f8c1ff",
                value: "pink",
            },
            {
                id: 8,
                color: "#ffffff",
                value: "white",
            },
            {
                id: 9,
                color: "#bbbbbb",
                value: "gray",
            },
            {
                id: 10,
                color: "#000000",
                value: "black",
            },
            {
                id: 11,
                color: "#ae5700",
                value: "brown",
            },
        ];
        showColorbox = false;
        isSetCheckbox = false;
        setTrans() {
            this.isSetCheckbox = true;
        }
        setGray() {
            this.isSetCheckbox = true;
            this.activeColor = "";
        }
        handle(e) {
            let objTarget = this.$refs.colorboxEl as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.showColorbox = false;
                document.removeEventListener("click", this.handle, true);
                this.isSetCheckbox && this.reloadWithParams();
                this.isSetCheckbox = false;
            }
        }
        toggleColor() {
            this.showColorbox = !this.showColorbox;
            document.addEventListener("click", this.handle, true);
        }
        clickColor(index) {
            this.showColorbox = false;
            document.removeEventListener("click", this.handle, true);
            this.activeColor = this.colorList[index].value;
            this.isSetCheckbox = false;
            this.reloadWithParams();
        }
        cleanColor() {
            this.isGray = false;
            this.isTransparent = false;
            this.activeColor = "";
        }
        get colors() {
            if (this.isGray) {
                if (this.isTransparent) {
                    return "grayscale, transparent";
                } else {
                    return "grayscale";
                }
            } else {
                if (this.isTransparent) {
                    return this.activeColor + ", transparent";
                } else {
                    return this.activeColor;
                }
            }
        }

        params = {
            image_type: "all",
            orientation: "all",
            colors: "",
            page: 1,
            pageSize: 20,
        };
        leftHeight = 0;
        rightHeight = 0;
        leftList = [];
        rightList = [];
        end = false;
        initList() {
            if (this.loading) return;
            this.loading = true;
            let p = Object.assign({ q: this.keyWord, lang: this.lang }, this.params);
            this.$edApi
                .getPixabayData(p)
                .then((res) => {
                    let data = res.data.hits;
                    this.sensors.track("searchSymbolResult", {
                        Catalogues: "editFileProcess",
                        search_words: this.keyWord,
                        search_class: "picture",
                        is_find_symbol: data.length > 0 ? "findSomething" : "noResult",
                    });
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        let svg = this.isSvg(item.vectorURL);
                        let obj = {
                            isSvg: svg ? true : false,
                            previewUrl: item.previewURL,
                            imgUrl: svg ? item.vectorURL : item.largeImageURL,
                            w: item.imageWidth,
                            h: item.imageHeight,
                        };
                        this.addToList(obj);
                    }
                    if (this.leftList.length + this.rightList.length == res.data.total) {
                        this.end = true;
                    }
                    this.$nextTick(() => {
                        this.registObserve();
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        addToList(data: any) {
            const boxWidth = 104;
            if (this.leftHeight <= this.rightHeight) {
                this.leftList.push(data);
                this.leftHeight += (data.h / data.w) * boxWidth + 8;
            } else {
                this.rightList.push(data);
                this.rightHeight += (data.h / data.w) * boxWidth + 8;
            }
        }
        reset() {
            this.cancelObserve();
            this.leftList = [];
            this.rightList = [];
            this.leftHeight = 0;
            this.rightHeight = 0;
            this.end = false;
            this.params = {
                image_type: "all",
                orientation: "all",
                colors: "",
                page: 1,
                pageSize: 20,
            };
            this.initScrollList();
        }
        backToPreview() {
            this.cleanColor();
            this.typeIndex = 0;
            this.directionIndex = 0;
            this.reset();
            this.status = 0;
        }
        resetParams() {
            this.cleanColor();
            this.typeIndex = 0;
            this.directionIndex = 0;
            this.reset();
            this.initList();
        }

        nextPage() {
            if (this.loading) return;
            this.loading = true;
            this.params.page += 1;
            let p = Object.assign({ q: this.keyWord, lang: this.lang }, this.params);
            this.$edApi
                .getPixabayData(p)
                .then((res) => {
                    let data = res.data.hits;
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        let svg = this.isSvg(item.vectorURL);
                        let obj = {
                            isSvg: svg ? true : false,
                            previewUrl: item.previewURL,
                            imgUrl: svg ? item.vectorURL : item.largeImageURL,
                            w: item.imageWidth,
                            h: item.imageHeight,
                        };
                        this.addToList(obj);
                    }
                    if (this.leftList.length + this.rightList.length == res.data.total) {
                        this.end = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        observe = null;
        registObserve() {
            this.cancelObserve();
            this.addObserve();
        }
        cancelObserve() {
            if (this.observe) {
                this.observe.unobserve(this.$refs.scrollEl);
                this.observe = null;
            }
        }
        addObserve() {
            if (this.observe) return;
            let dom = this.$refs.scrollEl;
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e: any) => {
                    if (e[0] && e[0].isIntersecting && !this.loading) {
                        console.log("next page");
                        this.nextPage();
                    }
                });
                this.observe.observe(dom);
            }
        }

        created() {
            this.getPreviewData();
        }
        mounted() {
            this.$bus.$on("pixabayShowAiDraw", () => {
                this.showAiDraw();
            });
        }
        beforeDestroy() {
            this.$bus.$off("pixabayShowAiDraw");
        }
    }
</script>
<i18n>
{
    "zh": {
        "all": "全部",
        "aiDraw": "AI绘画",
        "science": "科技",
        "backgrounds": "背景",
        "places": "建筑",
        "flower": "花",
        "city": "城市",
        "business": "商务",
        "educate": "教育",
        "starSky": "星空",
        "sky": "天空",
        "snow": "雪",
        "cartoon": "动漫",
        "car": "车",
        "animal": "动物",
        "figure": "人物",
        "travel": "旅游",
        "photo": "照片",
        "illustration": "插画",
        "vector": "矢量图",
        "allDirection": "任意方向",
        "horizontal": "横向",
        "vertical": "竖向",
        "reset": "重置",
        "transparent": "透明",
        "grayscale": "黑白",
        "nodata": "暂无数据",
        "placeholder": "搜索图片",
        "tips": "Pixabay上的所有内容均可免费用于印刷和数字的商业和非商业用户，”不允许的内容”中提到的情况除外，但请不要在其他平台上重新分发或出售 Pixabay 内容。"
    },
    "en": {
        "all": "All",
        "aiDraw": "AI Drawing",
        "science": "Technology",
        "backgrounds": "Background",
        "places": "Architecture",
        "flower": "Flower",
        "city": "City",
        "business": "Business",
        "educate": "Education",
        "starSky": "Starry sky",
        "sky": "Sky",
        "snow": "Snow",
        "cartoon": "Cartoon",
        "car": "Car",
        "animal": "Animal",
        "figure": "Figure",
        "travel": "Travel",
        "photo": "Photos",
        "illustration": "Illustrations",
        "vector": "Vector graphics",
        "allDirection": "Any orientation",
        "horizontal": "Horizontal",
        "vertical": "Vertical",
        "reset": "Reset",
        "transparent": "Transparent",
        "grayscale": "Black and White",
        "nodata": "No data",
        "placeholder": "Search pictures",
        "tips": "All content on Pixabay is free to use for commercial and non-commercial purposes, except as noted in \"Content Not Allowed By Pixabay License\". Please don't redistribute or sell Pixabay content on other platforms."
    },
    "fr": {
        "all": "Tout",
        "aiDraw": "Dessin AI",
        "science": "Technologie",
        "backgrounds": "Fond d'écran",
        "places": "Architecture",
        "flower": "Fleur",
        "city": "Ville",
        "business": "Business",
        "educate": "Éducation",
        "starSky": "Ciel étoilé",
        "sky": "Ciel",
        "snow": "Neige",
        "cartoon": "Cartoon",
        "car": "Voiture ",
        "animal": "Animal",
        "figure": "Silhouette",
        "travel": "Voyage",
        "photo": "Photos",
        "illustration": "Illustrations",
        "vector": "Graphiques vectoriels",
        "allDirection": "Toute orientation",
        "horizontal": "Horizontale",
        "vertical": "Verticale",
        "reset": "Réinitialiser",
        "transparent": "Transparent",
        "grayscale": "Noir et blanc",
        "tips": "Tout le contenu de Pixabay est libre d'être utilisé à des fins commerciales et non commerciales, sauf dans les cas indiqués dans la section « Contenu interdit par la licence Pixabay ». Il est interdit de redistribuer ou de vendre du contenu Pixabay sur d'autres plateformes."
    },
    "de": {
        "all": "Alle",
        "aiDraw": "AI Drawing",
        "science": "Technologie",
        "backgrounds": "Hintergrund",
        "places": "Architektur",
        "flower": "Blume",
        "city": "Stadt",
        "business": "Unternehmen",
        "educate": "Bildung",
        "starSky": "Sternenhimmel",
        "sky": "Himmel",
        "snow": "Schnee",
        "cartoon": "Zeichentrick",
        "car": "Auto",
        "animal": "Tier",
        "figure": "Figur",
        "travel": "Reisen",
        "photo": "Fotos",
        "illustration": "Illustrationen",
        "vector": "Vektorgrafiken",
        "allDirection": "Jegliche Ausrichtung",
        "horizontal": "Horizontal",
        "vertical": "Vertikal",
        "reset": "Zurücksetzen",
        "transparent": "Transparent",
        "grayscale": "Schwarz-weiß",
        "tips": "Alle Inhalte auf Pixabay können für kommerzielle und nicht kommerzielle Zwecke genutzt werden, außer wie unter „Nicht unter Pixabay Lizenz erlaubter Inhalt“ angegeben. Verbreiten oder verkaufen Sie Inhalt von Pixabay nicht auf anderen Plattformen."
    },
    "jp": {
        "all": "すべて",
        "aiDraw": "AI描画",
        "science": "テクノロジー",
        "backgrounds": "背景",
        "places": "建築",
        "flower": "花",
        "city": "都市",
        "business": "ビジネス",
        "educate": "教育",
        "starSky": "星空",
        "sky": "空",
        "snow": "雪",
        "cartoon": "漫画",
        "car": "車 ",
        "animal": "動物",
        "figure": "図",
        "travel": "旅行",
        "photo": "写真",
        "illustration": "イラスト",
        "vector": "ベクター",
        "allDirection": "すべて",
        "horizontal": "横",
        "vertical": "縦",
        "reset": "リセット",
        "transparent": "透明",
        "grayscale": "白黒",
        "tips": "Pixabayのすべてのコンテンツは、「Pixabayライセンスで許可されていないコンテンツ」に記載されている場合を除き、商用および非商用目的で自由に使用できます。Pixabayのコンテンツを他のプラットフォームに再配布または販売しないでください。"
    },
    "es": {
        "all": "Todo",
        "aiDraw": "Dibujo de AI",
        "science": "Tecnología",
        "backgrounds": "Fondo",
        "places": "Arquitectura",
        "flower": "Flor",
        "city": "Ciudad",
        "business": "Empresa",
        "educate": "Educación",
        "starSky": "Cielo estrellado",
        "sky": "Cielo",
        "snow": "Nieve",
        "cartoon": "Dibujos animados",
        "car": "Coche ",
        "animal": "Animal",
        "figure": "Figura",
        "travel": "Viajes",
        "photo": "Fotos",
        "illustration": "Ilustraciones",
        "vector": "Vectores",
        "allDirection": "Nada",
        "horizontal": "Horizontal",
        "vertical": "Vertical",
        "reset": "Restablecer",
        "transparent": "Transparente",
        "grayscale": "Blanco y negro",
        "tips": "Se puede utilizar todo el contenido de Pixabay para fines comerciales y no comerciales, excepto en los casos indicados en «Contenido no permitido por la licencia de Pixabay». No redistribuyas ni vendas contenido de Pixabay en otras plataformas."
    },
    "pt": {
        "all": "Todos",
        "aiDraw": "Desenho por IA",
        "science": "Tecnologia",
        "backgrounds": "Plano de fundo",
        "places": "Arquitetura",
        "flower": "Flor",
        "city": "Cidade",
        "business": "Negócios",
        "educate": "Educação",
        "starSky": "Céu estrelado",
        "sky": "Céu",
        "snow": "Neve",
        "cartoon": "Desenho animado",
        "car": "Carro ",
        "animal": "Animal",
        "figure": "Figura",
        "travel": "Viagem",
        "photo": "Fotos",
        "illustration": "Ilustrações",
        "vector": "Gráficos vetoriais",
        "allDirection": "Qualquer orientação",
        "horizontal": "Horizontal",
        "vertical": "Vertical",
        "reset": "Redefinir",
        "tips": "Todo o conteúdo do Pixabay é livre para uso comercial e não comercial, exceto conforme observado em \"Conteúdo não permitido pela licença Pixabay\". Não redistribua nem venda conteúdos do Pixabay em outras plataformas."
    },
    "it": {
        "all": "tutto",
        "aiDraw": "Disegno AI",
        "science": "Tecnologia",
        "backgrounds": "Sfondi",
        "places": "Architettura",
        "flower": "Fiori",
        "city": "Città",
        "business": "Business",
        "educate": "Istruzione",
        "starSky": "Cieli stellati",
        "sky": "Cieli",
        "snow": "Neve",
        "cartoon": "Cartoni animati",
        "car": "Automobili ",
        "animal": "Animali",
        "figure": "Aspetto fisico",
        "travel": "Viaggi",
        "photo": "Foto",
        "illustration": "Illustrazioni",
        "vector": "Grafica vettoriale",
        "allDirection": "Qualsiasi orientamento",
        "horizontal": "Orizzontale",
        "vertical": "Verticale",
        "reset": "Ripristina",
        "transparent": "Trasparenza",
        "grayscale": "Bianco e nero",
        "tips": "Tutti i contenuti su Pixabay sono gratuiti per scopo commerciale e non. Fa eccezione quando indicato nella sezione dedicata al \"contenuto non disponibile dalla licenza Pixabay\". Non ridistribuire o vedere contenuti Pixabay su altre piattaforma."
    },
    "tw": {
        "all": "全部",
        "aiDraw": "AI 繪圖",
        "science": "技術",
        "backgrounds": "背景",
        "places": "結構",
        "flower": "花朵",
        "city": "城市",
        "business": "商務",
        "educate": "教育",
        "starSky": "星空",
        "sky": "天空",
        "snow": "下雪",
        "cartoon": "卡通",
        "car": "汽車 ",
        "animal": "動物",
        "figure": "人物",
        "travel": "旅遊",
        "photo": "相片",
        "illustration": "插畫",
        "vector": "向量圖形",
        "allDirection": "任何方向",
        "horizontal": "水平",
        "vertical": "垂直",
        "reset": "重設",
        "transparent": "透明",
        "grayscale": "黑白",
        "tips": "Pixabay 上的所有內容均可免費用於商業和非商業用途，但在「Pixabay 授權不允許的內容」中註明的除外。請勿在其他平台上轉散布或銷售 Pixabay 內容。"
    },
    "kr": {
        "all": "모두",
        "aiDraw": "AI 드로잉",
        "science": "기술",
        "backgrounds": "배경",
        "places": "건축",
        "flower": "꽃",
        "city": "도시",
        "business": "사업",
        "educate": "교육",
        "starSky": "밤하늘",
        "sky": "하늘",
        "snow": "눈",
        "cartoon": "카툰",
        "car": "자동차 ",
        "animal": "동물",
        "figure": "피규어",
        "travel": "여행",
        "photo": "사진",
        "illustration": "일러스트",
        "vector": "벡터 그래픽",
        "allDirection": "모든 방향",
        "horizontal": "수평",
        "vertical": "수직",
        "reset": "재설정",
        "transparent": "투명도",
        "grayscale": "흑백",
        "tips": "Pixabay의 모든 콘텐츠는 상업용 또는 비상업용 용도로 무료로 사용 가능합니다(‘Content Not Allowed By Pixabay License’ 표시가 있는 경우 제외). Pixabay 콘텐츠를 다른 플랫폼에 재배포하거나 판매하지 마십시오."
    }
}
</i18n>
